import { Card, Skeleton, SkeletonItem, Spinner } from '@fluentui/react-components';

export const LoadingState = ({ label = 'Loading data...' }: { label?: string }) => (
  <Card>
    <Spinner label={label} />
    <Skeleton>
      <SkeletonItem shape="rectangle" />
      <SkeletonItem shape="rectangle" />
      <SkeletonItem shape="rectangle" />
    </Skeleton>
  </Card>
);
